import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { PdpPublicationsDialogComponent } from './pdp-publications-dialog.component'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'
import { MbI18nModule } from '../../../../../translations/mb-i18n.module'

@NgModule({
  declarations: [PdpPublicationsDialogComponent],
  imports: [
    CommonModule,
    NgbModule,
    MbI18nModule,
  ]
})
export class PdpPublicationsDialogModule { }
